var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14286 0C1.77406 0 2.28571 0.55965 2.28571 1.25V8.75C2.28571 9.44038 1.77406 10 1.14286 10C0.51168 10 0 9.44038 0 8.75V1.25C0 0.55965 0.51168 0 1.14286 0ZM6.85714 0C7.48834 0 8 0.55965 8 1.25V8.75C8 9.44038 7.48834 10 6.85714 10C6.22594 10 5.71429 9.44038 5.71429 8.75V1.25C5.71429 0.55965 6.22594 0 6.85714 0Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.674a1ed1984c95433b73ae484a1a20fb.svg";
export { ForwardRef as ReactComponent };